import { Controller } from "stimulus";
import "select2"
import {
  parseShipmentAddress,
  removeHtmlChildren,
  setHtmlElementValue
} from "../utils/utils";


export default class extends Controller {
    static targets = [ "companyId", "user", "userShipmentAddress" ];

    initialize() {
    }


    // Funzione che gestisce il cambio del loop merchant abbinato alla submission list
    handleChangeUser() {
        setHtmlElementValue(document, "user_shipment_address_id", null);

        const url = `/backoffice/companies/${this.companyIdTarget.value}/users/get_all_addresses/${this.userTarget.value}`;

        fetch(url, {
            method: "GET"
        })
          .then((response) => {
              if (!response.ok)
                  throw Error("An error occour during saving data on the database");
              else
                  return response.json();
          })
          .then((addresses) => {
              this.fillAddressesSelect(this.userShipmentAddressTarget, addresses);
          })
          .catch((error) => {
              console.error("ERROR:", error);
          });
    }




  // Funzione che renderizza sull'interfaccia grafica gli indirizzi dell'utente / aggregatore della submission list
  fillAddressesSelect(target, addresses) {
    removeHtmlChildren(target);

    target.insertAdjacentHTML(
      "beforeend",
      "<option value=''>Select address</option>"
    );

    for (const address of addresses) {
      console.log('address: ', address)
      console.log('address.id.toString().indexOf(\'new\') > -1: ', address.id.toString().indexOf('new') > -1)
      target.insertAdjacentHTML(
        "beforeend",
        `<option value='${address.id}'>` + (address.id.toString().indexOf('new') > -1 ? 'New Address' : parseShipmentAddress(address)) + "</option>"
      );
    }
  }
}